// extracted by mini-css-extract-plugin
export default {"pm-issue-table":"components-parity-parity-manager-table-issues-module__pm-issue-table"};